import PropTypes from 'prop-types';
import React from 'react';
import Dialog from 'components/Molecules/Dialog';

const DeleteEmployee = ({
  handleComment,
  handleCancel,
  secondaryBtn,
  primaryBtn,
  primaryBtnColor,
  userName,
  open,
  handleClose,
}) => {
  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      dialogTitle="Delete Employee"
      dialogDesc={`Are you sure you want to delete ${userName}?`}
      secondaryBtn={secondaryBtn}
      primaryBtn={primaryBtn}
      handlePrimaryBtn={handleComment}
      handleSecondaryBtn={handleCancel}
      primaryBtnColor={primaryBtnColor}
      bodyContent={false}
    />
  );
};
DeleteEmployee.defaultProps = {
  userName: 'Uday kumar',
  primaryBtnColor: 'error',
  secondaryBtn: 'Cancel',
  primaryBtn: 'Delete',
  handleComment: () => {},
  handleCancel: () => {},
  open: true,
  handleClose: () => {},
};
DeleteEmployee.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  primaryBtnColor: PropTypes.string,
  userName: PropTypes.string,
  handleComment: PropTypes.func,
  handleCancel: PropTypes.func,
  secondaryBtn: PropTypes.string,
  primaryBtn: PropTypes.string,
};
export default DeleteEmployee;
